<template>
  <div>
    <div class="call">
      <b-container>
        <div class="box1">
          <h1>联系我们</h1>
          <p>— CONTACT US —</p>
          <span>{{concat}}
          </span>
        </div>
        <b-row>
          <b-col><img src="../assets/icon_Add.png" class="img">
            <div class="box2">
              <p>联系地址</p>
              <p>{{address}}</p>
            </div>
          </b-col>
          <b-col><img src="../assets/icon_Tel.png" class="img">
            <div>
              <p>联系电话</p>
              <p>{{phone}}</p>
            </div>
          </b-col>
          <b-col><img src="../assets/icon_Email.png" class="img">
            <div>
              <p>联系邮箱</p>
              <p>{{email}}</p>
            </div>
          </b-col>
        </b-row>
        <div class="box3">
          <img :src="wechat_code" class="img">
          <p>关注微信</p>
        </div>
      </b-container>
    </div>
    <div class="footer">
      <p>{{copyright}}</p>
    </div>
  </div>

</template>

<script>
  import axios from 'axios'
  import local from '../utils/local'

  export default {
    data() {
      return {
        concat:"",
        address:"",
        phone:"",
        email:"",
        wechat_code:"",
        copyright:""
      };
    },
    created() {
      this.getInfo()
    },

    methods: {
      getInfo() {
        axios.post('http://api1.home.didigo.es/admin/admin/index').then(res => {

          this.concat = res.data.data.par[0].contact;
          this.address = res.data.data.par[0].address;
          this.phone = res.data.data.par[0].phone;
          this.email = res.data.data.par[0].email;
          this.wechat_code = res.data.data.msg[0].wechat;
          this.copyright = res.data.data.par[0].copyright;
        })
        
      }
    }
  };
</script>

<style lang="less">
  .box1 {
    text-align: center;

    h1 {
      font-size: 24px;
      font-weight: bold;
      color: #333;
    }

    p {
      font-size: 14px;
      color: #666;
      margin-bottom: 10px;
    }

    span {
      color: #808080;
      font-size: 16px;
    }
  }

  .call {
    padding: 80px 0 120px 0;

    background: #F2F6FC;

    .row {
      margin-top: 80px;

      .col {
        display: flex;
        align-items: center;

        p {
          margin: 0;
          font-size: 14px;
          color: #666;
        }

        .img {
          padding: 5px 20px 0 0;
          height: 32px;
          border-right: 1px solid #e5e5e5;
          margin-right: 20px;
        }
      }
    }

    .box3 {
      margin-top: 80px;
      text-align: center;

      .img {
        width: 120px;
      }

      p {
        padding: 10px 0;
        font-size: 14px;
        color: #666;
      }
    }
  }

  .footer {
    text-align: center;
    width: 100%;
    height: 90px;
    font-size: 12px;
    color: #999;
    line-height: 90px;

    p {
      margin-bottom: 0;
    }
  }
</style>